export default {
    // W
    writeup: 'Write Up',
}
